import { formatWalletAddress } from '@/utils/formatWalletAddress';

/** Key within the `layout` message namespace. */
export const getPageNameKey = (pathname: string): string => {
  if (pathname === '/overview') {
    return 'nav.analytics';
  }

  if (pathname === '/overview/reserve') {
    return 'nav.reserve';
  }

  if (pathname === '/overview/governance') {
    return 'nav.governance';
  }

  if (pathname === '/liquidity-pool') {
    return 'nav.liquidityPool';
  }

  if (pathname === '/yield-bearing-vaults') {
    return 'nav.yieldBearingVaults';
  }

  if (pathname === '/wallet') {
    return 'nav.wallet';
  }

  if (pathname === '/unit-bridge') {
    return 'nav.unitBridge';
  }

  if (pathname === '/swap') {
    return 'nav.swap';
  }

  if (pathname === '/faucet') {
    return 'nav.faucet';
  }

  if (pathname === '/liquidations') {
    return 'nav.liquidations';
  }

  if (pathname === '/liquidations/leaderboard') {
    return 'nav.leaderboard';
  }

  if (pathname === '/liquidations/claim') {
    return 'nav.claim';
  }

  if (pathname === '/quanta') {
    return 'nav.quanta';
  }

  if (pathname === '/quanta/missions') {
    return 'nav.missions';
  }

  if (pathname === '/quanta/side-missions') {
    return 'nav.sideMissions';
  }

  if (pathname === '/quanta/leaderboard') {
    return 'nav.leaderboard';
  }

  return 'nav.vault';
};

export const getFormattedAddress = (address: string | null, isMobile: boolean): string | null => {
  if (isMobile) {
    return formatWalletAddress(address, 3, 3);
  }

  return formatWalletAddress(address, 12, 5);
};
